import axiosInstance from "../utils/axios";

export const getPackageListAPI = async () => {
    try {
        const response = await axiosInstance.get("/api/user/package/package-list");
        if (!response.data.status) {
            throw new Error(response.data.message);
        }
        return response.data;
    } catch (error: any) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw new Error(error.message || "Failed to get package list");
    }
};

export const purchasePackageAPI = async (payload: { package_id: string, payment_method: string, device_type?: string }) => {
    try {
        const response = await axiosInstance.post(`/api/user/package/purchase-package`, payload);
        if (!response.data.status) {
            throw new Error(response.data.message);
        }
        return response.data;
    } catch (error: any) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw new Error(error.message || "Failed to purchase package");
    }
};

export const getPurchaseHistoryAPI = async (page: number = 1, per_page: number = 10) => {
    try {
        const response = await axiosInstance.get("/api/user/package/package-purchase-list", {
            params: { page, per_page }
        });
        if (!response.data.status) {
            throw new Error(response.data.message);
        }
        return response.data;
    } catch (error: any) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw new Error(error.message || "Failed to get purchase history");
    }
};

export const getPackageVatPercentageAPI = async () => {
    try {
        const response = await axiosInstance.get("/api/user/package/vat-percentage");
        if (!response.data.status) {
            throw new Error(response.data.message);
        }
        return response.data;
    } catch (error: any) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw new Error(error.message || "Failed to get VAT percentage");
    }
};